import styled from 'styled-components'

const ImgStyle = styled.img`
    width: ${props => props.width + 'px'};
    height: ${props => props.height + 'px'};
`

export {
	ImgStyle,
}